module.exports = __webpack_public_path__ + "img/dedusting.eee04d28.jpg";